var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-screen',{attrs:{"title":"Tasks","toolbar":"tasks","menu":true}},[_c('div',{staticClass:"categories-text",domProps:{"innerHTML":_vm._s(_vm.texts.ca.text)}}),_vm._l((_vm.categories),function(category){return _c('com-category',{key:category.id,attrs:{"item":category}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }